import AgreementLinksTooltip from './agreement-links-tooltip';
export default AgreementLinksTooltip;
